<template>
    <div class="channel-card">
        <div class="channel-card__left">
            <div class="channel-card__left--title">{{ title }}</div>
            <div class="channel-card__left--time-release">
                <div class="channel-card__left--content">{{ content }}</div>
                <vue-countdown
                    :time="milliseconds(secondLeft)"
                    v-slot="{ hours, minutes, seconds }"
                >
                    <span>{{ hours.toString().padStart(2, '0') }}</span> :
                    <span>{{ minutes.toString().padStart(2, '0') }}</span> :
                    <span>{{ seconds.toString().padStart(2, '0') }}</span>
                </vue-countdown>
            </div>
        </div>
        <div class="channel-card__right">
            <div class="channel-card__right--logo mx-1">
                <picture class="kqsx-result__channel-logo-icon d-inline-block">
                    <source
                        :srcset="
                            require('@/assets/images/channel-logo/' +
                                getLogoName(channelId) +
                                '.webp')
                        "
                        type="image/webp"
                    />
                    <img
                        :src="
                            require('@/assets/images/channel-logo/' +
                                getLogoName(channelId) +
                                '.png')
                        "
                        :alt="getLogoName(channelId)"
                    />
                </picture>
            </div>
            <div class="channel-card__right--action">
                <router-link
                    :to="{
                        name: channelName,
                        params: { reBet: { city_id: channelId } },
                    }"
                    :class="'stretched-link'"
                >
                    <Button
                        value="Chọn"
                        variant="btn__blue"
                        class="classes"
                    />
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Button from '../Button/Button';
import channelLogoJson from '@/assets/common/json/channel-logo.json';
import timeMixin from '@/mixins/time.mixin';

export default Vue.extend({
    name: 'ChannelCard',
    mixins: [timeMixin],
    props: {
        channelId: {
            type: Number,
            required: false,
        },
        title: {
            type: String,
            required: false,
        },
        content: {
            type: String,
            required: false,
            default: 'Giờ xổ số',
        },
        secondLeft: {
            type: String,
            required: false,
        },
        channelName: {
            type: String,
            required: false,
        },
    },
    components: {
        Button,
    },
    methods: {
        getLogoName: function(channelId) {
            return channelLogoJson[channelId.toString()]
                ? channelLogoJson[channelId.toString()].logo
                : 'not_found';
        },
    },
});
</script>
